import { render } from "./Photos.vue?vue&type=template&id=b1b91140"
import script from "./Photos.vue?vue&type=script&lang=ts"
export * from "./Photos.vue?vue&type=script&lang=ts"
script.render = render

export default script